// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_iO6l2LzEDPyEkGjPXhyfHIw3Td3rRFo",
  authDomain: "plannr-b6a47.firebaseapp.com",
  projectId: "plannr-b6a47",
  storageBucket: "plannr-b6a47.appspot.com",
  messagingSenderId: "284919953386",
  appId: "1:284919953386:web:f6f1ed4aae62332860a493",
  measurementId: "G-LKJP7QWN0Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Get Firebase auth instance

export default auth;